import { render } from "./AddRequesterModal.vue?vue&type=template&id=9764905c"
import script from "./AddRequesterModal.vue?vue&type=script&lang=js"
export * from "./AddRequesterModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__